import { h } from 'preact';
import { normalizeToUsPlusOnePhone } from '../utils/utils';
import TxrInput from './txr-input';

const TxrPhoneInput = (props) => {
    const model = props.model;
    const normalizeChangeArgs = props.normalizeChangeArgs || [];

    if (model) {
        model.onBlur = (inputModel) => {
            const normalized = normalizeToUsPlusOnePhone(inputModel.value);
            if (normalized) {
                inputModel.value = normalized;
            }
            if (inputModel.change) {
                inputModel.change(inputModel, ...normalizeChangeArgs);
            }
        };
    }

    return (
        <TxrInput
            {...props}
            model={model}
            floatingPlaceholder
        />
    );
};

export default TxrPhoneInput;
